import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Dedicated axios instance so it never mixes with the staff/agency auth token
export const commApi = axios.create({ baseURL: API });
commApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('community_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const CommunityContext = createContext();

export const useCommunity = () => {
  const ctx = useContext(CommunityContext);
  if (!ctx) throw new Error('useCommunity must be used within CommunityProvider');
  return ctx;
};

export const photoUrl = (path) => {
  if (!path) return null;
  const token = localStorage.getItem('community_token');
  return `${API}/community/files/${path}?auth=${token}`;
};

export const CommunityProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('community_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem('community_token');
    if (!t) {
      setLoading(false);
      return;
    }
    commApi
      .get('/community/auth/me')
      .then((r) => setMember(r.data))
      .catch(() => {
        localStorage.removeItem('community_token');
        setToken(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const persist = (data) => {
    localStorage.setItem('community_token', data.token);
    setToken(data.token);
    setMember(data.member);
  };

  const register = async (payload) => {
    const { data } = await commApi.post('/community/auth/register', payload);
    persist(data);
    return data.member;
  };

  const login = async (email, password) => {
    const { data } = await commApi.post('/community/auth/login', { email, password });
    persist(data);
    return data.member;
  };

  const logout = () => {
    localStorage.removeItem('community_token');
    setToken(null);
    setMember(null);
  };

  const refreshMe = async () => {
    const { data } = await commApi.get('/community/auth/me');
    setMember(data);
    return data;
  };

  return (
    <CommunityContext.Provider
      value={{ member, token, loading, register, login, logout, refreshMe, setMember }}
    >
      {children}
    </CommunityContext.Provider>
  );
};
